import { Link } from 'react-router-dom';

export default function About() {
  return (
    <section id="about" className="section-padding bg-background-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-primary-500 font-bold text-sm tracking-widest uppercase mb-4">
          BİZ BU AJANSTA
        </p>
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 tracking-tighter mb-6">
          İŞİMİZİ KONUŞURUZ.
        </h2>

        {/* GEO Entity Brief — shortened for homepage */}
        <div className="glass-card rounded-2xl p-6 md:p-8 mb-8 text-left speakable-summary">
          <h3 className="text-sm font-bold text-primary-500 uppercase tracking-wider mb-3">
            Biff DIGITAL Kimdir?
          </h3>
          <p className="text-base md:text-lg text-foreground-200 leading-relaxed">
            <strong>Biff Digital, Ankara merkezli, İstanbul ve İzmir'de hizmet veren tam hizmet bir B2B dijital pazarlama ve reklam ajansıdır.</strong>
            {' '}Marka konumlandırması, dijital reklam, web geliştirme, e-ticaret, B2B lead generation ve içerik üretimi alanlarında
            <strong> veri odaklı stratejiler</strong> ve <strong>ölçülebilir sonuçlar</strong> sunar.
          </p>
        </div>

        <p className="text-base md:text-lg text-foreground-300 leading-relaxed max-w-2xl mx-auto">
          Sıradışı fikirlere inanır, onları her mecrada hayata geçiririz.
          Ülkenin ve bölgenin en büyük, en cesur markalarını daha da büyütmek için çalışırız.
          Veriyle konuşuruz. Yaratıcılıkla vururuz. Sonuçları getiririz.
        </p>

        <div className="mt-10 md:mt-14 space-y-3 text-foreground-400">
          <p className="text-sm font-semibold text-foreground-300 uppercase tracking-wider">Tanışalım</p>
          <a
            href="mailto:info@biffdigital.com"
            className="text-foreground-200 hover:text-primary-500 transition-colors text-base md:text-lg font-bold"
          >
            info@biffdigital.com
          </a>
          <p className="text-sm mt-6 font-semibold text-foreground-300 uppercase tracking-wider">Bize Katıl</p>
          <a
            href="mailto:info@biffdigital.com"
            className="text-foreground-200 hover:text-primary-500 transition-colors text-base md:text-lg font-bold"
          >
            info@biffdigital.com
          </a>
          <p className="text-sm mt-8 font-semibold text-foreground-300 uppercase tracking-wider">Sosyal Medya</p>
          <div className="flex flex-wrap items-center justify-center gap-4 mt-2">
            <a
              href="https://www.instagram.com/biffdigital"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground-200 hover:text-primary-500 transition-colors text-base md:text-lg font-bold inline-flex items-center gap-2"
            >
              <i className="ri-instagram-line" />
              Instagram
            </a>
            <a
              href="https://www.youtube.com/@Biff-Digital"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground-200 hover:text-primary-500 transition-colors text-base md:text-lg font-bold inline-flex items-center gap-2"
            >
              <i className="ri-youtube-line" />
              YouTube
            </a>
            <a
              href="https://www.linkedin.com/company/biff-digital"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground-200 hover:text-primary-500 transition-colors text-base md:text-lg font-bold inline-flex items-center gap-2"
            >
              <i className="ri-linkedin-line" />
              LinkedIn
            </a>
          </div>

          {/* Link to full About page */}
          <div className="mt-10 pt-6 border-t border-background-200/60">
            <Link to="/ankara-dijital-pazarlama-ajansi" className="inline-flex items-center gap-2 text-sm font-bold text-primary-500 hover:text-primary-600 transition-colors uppercase tracking-wider">
              Detaylı Bilgi, Ekibimiz ve S.S.S.
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}